/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgMoneyBook = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M1 2a1 1 0 0 1 1-1h6.001A3.99 3.99 0 0 1 11 2.354 3.99 3.99 0 0 1 13.999 1H20a1 1 0 0 1 1 1v8h-2V3h-5.001A2 2 0 0 0 12 4.999v15a1 1 0 1 1-2 0c0-1.106-.894-2-2-2H2a1 1 0 0 1-1-1zm9 14.534V4.999A2 2 0 0 0 8.001 3H3v12.999h5c.729 0 1.412.195 2 .535z" />
        <path d="M18 13v-1h2v1h3v2h-3v2h1a3 3 0 1 1 0 6h-1v1h-2v-1h-3v-2h3v-2h-1a3 3 0 1 1 0-6zm0 2h-1a1 1 0 1 0 0 2h1zm2 4v2h1a1 1 0 1 0 0-2z" />
      </g>
    </g>
  </Icon>
);
export { SvgMoneyBook as MoneyBook };
